// Production backend. Local Django is http://127.0.0.1:8000
export const BASE_URL = 'https://ab-finance-api-dev.jazeeautomation.com';

